export const XL = {
  min: 1441,
  max: Number.MAX_SAFE_INTEGER
};
export const LG = {
  min: 992,
  max: 1440
};
export const MD = {
  min: 768,
  max: 991
};
export const SM = {
  min: 576,
  max: 767
};
export const XS = {
  min: 0,
  max: 575
};
export const breakpoints = {
  xl: XL,
  lg: LG,
  md: MD,
  sm: SM,
  xs: XS
};
export const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
export default breakpoints;